<template>
  <div>
    <Panel :isActive="openPanels.includes('services')" :title="t.getOrKey('Label.SelectServices')" ref="servicesPanel">
      <template v-slot:icon>
        <font-awesome-icon :icon="['fas', 'layer-group']"></font-awesome-icon>
      </template>
      <ServiceSelector @change="selectedServicesChanged"></ServiceSelector>
    </Panel>
    <Panel :isActive="openPanels.includes('provider')" :title="t.getOrKey('Label.SelectProvider')" ref="providerPanel">
      <template v-slot:icon>
        <font-awesome-icon :icon="['fas', 'map-marker-alt']"></font-awesome-icon>
      </template>
      <ProviderSelector ref="providerSelector" :selectedServices="reservation.services.map((s) => s.id)"
        @change="selectedProviderChanged"></ProviderSelector>
    </Panel>
    <Panel :isActive="openPanels.includes('time')" :title="t.getOrKey('Label.SelectTime')" ref="timePanel">
      <template v-slot:icon>
        <font-awesome-icon :icon="['fas', 'clock']"></font-awesome-icon>
      </template>

      <DateTimeSelector ref="dateTimeSelector" 
        @change="selectedSlotChanged" 
        :selectedServiceIds="selectedServiceIds"
        :selectedProviderId="selectedProviderId" 
        :scheduleInfo="currentScheduleInfo" 
        :selectedSlot="reservation.slot"
        :reservationId="reservation.slot ? reservation.slot.reservationId : undefined" 
        :closeProviders="closeProviders"></DateTimeSelector>
    </Panel>
    <Panel :isActive="openPanels.includes('contact')" :title="t.getOrKey('Label.Contact')" ref="contactPanel">
      <template v-slot:icon>
        <font-awesome-icon :icon="['fas', 'user-edit']"></font-awesome-icon>
      </template>
      <ReserverDetails ref="reserverDetails" @change="reserverDetailsChanged"></ReserverDetails>
    </Panel>
    <Panel :isActive="openPanels.includes('questions')" :title="t.getOrKey('Label.AdditionalQuestionsAndServices')"
      ref="questions">
      <template v-slot:icon>
        <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon>
      </template>

      <ServiceAdditionalOptions @change="optionsChanged" :additional-options="
        reservation.services.reduce((acc, curVal) => {
          return acc.concat(curVal.additionalOptions);
        }, [])
      " :selected-options="
  reservation.services.reduce((acc, curVal) => {
    return acc.concat(curVal.selectedOptions);
  }, [])
" :disabled="false"></ServiceAdditionalOptions>

      <ServiceAdditionalQuestions :additionalQuestions="
        reservation.services.reduce((acc, curVal) => {
          return acc.concat(
            curVal.additionalQuestions.map((aq) => ({
              ...aq,
              serviceId: curVal.id,
            }))
          );
        }, [])
      " :given-answers="
  reservation.services.reduce((acc, curVal) => {
    return acc.concat(curVal.givenAnswers);
  }, [])
" :disable="false" @change="answersChanged" ref="additionalQuestionsRef">
      </ServiceAdditionalQuestions>
    </Panel>
    <Panel :isActive="openPanels.includes('summary')" :title="t.getOrKey('Label.Summary')" ref="summaryPanel">
      <template v-slot:icon>
        <font-awesome-icon :icon="['fas', 'tasks']"></font-awesome-icon>
      </template>
      <ReservationSummary v-if="reservation.slot" :reservation="reservation" @reservationSlotTaken="reloadSlots"
        @validate="validate"></ReservationSummary>
    </Panel>
  </div>
</template>
<script>
import Panel from "./Panel.vue";
import ServiceSelector from "./ServiceSelector.vue";
import ProviderSelector from "./ProviderSelector.vue";
import DateTimeSelector from "./DateTimeSelector.vue";
import ReserverDetails from "./ReserverDetails.vue";
import ReservationSummary from "./ReservationSummary.vue";
import t from "@/services/translation-service";
import ServiceAdditionalQuestions from "./ServiceAdditionalQuestions.vue";
import utils from "@/services/utils";
import Vue from "vue";
import ServiceAdditionalOptions from "./ServiceAdditionalOptions.vue";

export default {
  name: "ReservationBuilder",
  data() {
    return {
      t: t,
      closeProviders: [],
      reservation: {
        services: [],
        provider: undefined,
        slot: null,
        name: "",
        email: "",
        phone: "",
        additionalInfo: "",
        registration: "",
      },
      openPanels: ["services"],
      scrollScheduled: false,
    };
  },
  computed: {
    selectedProviderId() {
      return this.reservation.provider?.id;
    },
    selectedServiceIds() {
      return this.reservation.services.map((f) => f.id);
    },
    currentScheduleInfo() {
      return this.reservation.services
        .map((f) => f.additionalInfoForSchedule)
        .join("\n\n");
    },
  },
  methods: {
    handleOpenPanels() {
      const panels = ["services"];
      if (this.reservation.services.length) {
        panels.push("provider");
      }
      if (this.reservation.provider && this.reservation.provider.id) {
        panels.push("time");
      }
      if (this.reservation.slot && this.reservation.slot.id) {
        panels.push("contact");
        panels.push("questions");
        panels.push("summary");
      }
      this.openPanels = panels;
    },
    activatePanel(panel) {
      this.activePanel = panel;
    },
    scrollToLatestPanel(panelName, scrollDelay) {
      const vm = this;
      if (!vm.scrollScheduled) {
        vm.scrollScheduled = true;
        setTimeout(() => {
          const el = panelName
            ? vm.$refs[panelName].$el
            : vm.$refs[vm.openPanels[vm.openPanels.length - 1] + "Panel"].$el;
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
          vm.scrollScheduled = false;
        }, scrollDelay || 200);
      }
    },
    selectedServicesChanged(selected) {
      this.reservation.services = selected;
      this.handleOpenPanels();
      if (this.$refs.providerSelector) {
        this.$refs.providerSelector.clearData();
      }
      this.scrollToLatestPanel();
    },
    selectedProviderChanged(provider, closeProviders) {
      this.reservation.provider = provider;
      this.closeProviders = closeProviders ?? [];
      this.handleOpenPanels();
      if (this.$refs.dateTimeSelector) {
        this.$refs.dateTimeSelector.clearData();
      }
      this.scrollToLatestPanel(undefined, 1000);
    },
    selectedSlotChanged(slot) {
      if (slot) {
        this.reservation.slot = slot;
        if(slot.provider?.name?.length){
          this.reservation.provider = slot.provider;
          if(this.$refs.providerSelector){
            this.$refs.providerSelector.setProvider(slot.provider);
          }
        }       
       
      } else if (this.reservation.slot) {
        this.reservation.slot = {
          reservationId: this.reservation.slot.reservationId,
        };
      }

      this.handleOpenPanels();
      if (this.openPanels.includes("contact")) {
        this.scrollToLatestPanel("contactPanel");
      } else {
        this.scrollToLatestPanel();
      }
    },
    reloadSlots() {
      this.$refs.dateTimeSelector.reloadSlots();
    },
    reserverDetailsChanged(data) {
      this.reservation.name = data.name;
      this.reservation.phone = data.phone;
      this.reservation.email = data.email;
      this.reservation.additionalInfo = data.additionalInfo;
      this.reservation.registration = data.registration;
    },
    optionsChanged(options) {
      const handledServiceIds = [];
      options.map((option) => {
        if (!handledServiceIds.some((f) => f === option.serviceId)) {
          const sIndex = this.reservation.services.findIndex(
            (f) => f.id === option.pServiceId
          );
          const s = utils.clone(this.reservation.services[sIndex]);
          s.selectedOptions = options.filter((f) => f.pServiceId === s.id);
          handledServiceIds.push(option.serviceId);
          Vue.set(this.reservation.services, sIndex, s);
        }
      });
    },
    answersChanged(questions) {
      questions.map((q) => {
        q.groupQuestions.map((gq) => {
          const sIndex = this.reservation.services.findIndex(
            (f) => f.id === gq.serviceId
          );
          const s = utils.clone(this.reservation.services[sIndex]);
          const aq = s.additionalQuestions.find((f) => f.id === gq.id);
          const answer = {
            hasValueChanged: q.hasValueChanged,
            value: q.value,
            question: aq,
            isValid: q.isValid,
            displayValue: q.displayValue,
          };
          s.givenAnswers = (
            s.givenAnswers.filter(
              (f) => f?.question?.id !== answer.question.id
            ) ?? []
          ).concat([answer]);
          Vue.set(this.reservation.services, sIndex, s);
        });
      });
    },
    validate(data) {
      this.$refs.reserverDetails.validate(data);
      if (this.$refs.additionalQuestionsRef) {
        this.$refs.additionalQuestionsRef.validateAll().then((isValid) => {
          if (data.isValid) {
            if (!isValid) {
              data.isValid = false;
              data.scrollTo = "questions";
              this.scrollToLatestPanel(data.scrollTo);
            }
          } else {
            this.scrollToLatestPanel(data.scrollTo);
          }
        });
      } else if (!data.isValid) {
        this.scrollToLatestPanel(data.scrollTo);
      }
    },
  },
  components: {
    Panel,
    ServiceSelector,
    ProviderSelector,
    DateTimeSelector,
    ReserverDetails,
    ReservationSummary,
    ServiceAdditionalQuestions,
    ServiceAdditionalOptions,
  },
};
</script>
